import { render, staticRenderFns } from "./CountryLink.vue?vue&type=template&id=3869838d&scoped=true"
import script from "./CountryLink.vue?vue&type=script&lang=js"
export * from "./CountryLink.vue?vue&type=script&lang=js"
import style0 from "./CountryLink.vue?vue&type=style&index=0&id=3869838d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3869838d",
  null
  
)

export default component.exports